// Deutsch (de-DE)
export default {
  AppHeader: {
    connect: "Verbinden",
    connecting: "Verbinde…",
    failed: "Wallet-Verbindung fehlgeschlagen",
  },
  AnnouncementPopup: {
    announceTag: "Ankündigung",
    close: "Schließen",
    gotIt: "Verstanden",
    morePrefix: "Noch ",
    moreSuffix: " weitere",
  },
  WalletRequired: {
    title: "Bitte in einer Wallet-App öffnen",
    desc: "Diese Seite benötigt eine Wallet-Umgebung. Öffne diesen Link in einer der unten aufgeführten Wallet-Apps.",
    tip: "Schon in der Wallet und siehst diese Seite trotzdem? Lade die Seite neu oder prüfe, ob die Wallet entsperrt ist.",
  },
  MobileTabBar: {
    home: "Start",
    pool: "Pool",
    service: "Service",
    invite: "Einladen",
    account: "Konto",
  },
  HomeView: {
    claimCoupon: "Gutschein einlösen",
    timedIncome: "Zeitbasierte Erträge",
    joinNode: "Node beitreten und mit dem Mining starten",
    processing: "Wird verarbeitet",
    receive: "Empfangen",
    poolData: "Pool-Daten",
    totalOutput: "Gesamtertrag",
    activeNodes: "Aktive Nodes",
    participants: "Teilnehmer",
    userRevenue: "Nutzererträge",
    mining: "Mining",
    liquidityIncome: "Erträge aus Liquidity-Mining",
    outputDetails: "Ertragsdetails",
    address: "Adresse",
    amount: "Menge",
    noData: "Keine Daten",
    helpCenter: "Hilfecenter",
    helpSubtitle: "Wir hoffen, es hilft dir weiter",
    auditors: "Auditoren",
    auditorsSubtitle: "Wir verfügen über sichere Auditberichte",
    partners: "Partner",
    partnersSubtitle: "Unsere Geschäftspartner",
    web3Robot: "Web3.0 Smart Robot",
    securityAuth: "Sicherheitszertifizierung",
    announce:
      "Beantrage die Masternode-Qualifikation, nimm am Liquidity-Mining teil und erziele hohe Renditen.",
    robotPoolData: "Smart-Robot-Pool",
    totalOut: "Gesamtertrag",
    validNodes: "Gültige Nodes",
    joinCount: "Teilnehmer",
    userEquity: "Nutzerguthaben",
    vipPool: "VIP-Pool",
    vipBannerTitle: "VIP-Premium-Mining-Pool",
    vipBannerDesc: "Jetzt bewerben und 30 Tage lang doppelte Mining-Erträge sichern",
    totalIncomeAll: "Kumulierte Erträge",
    vipRate: "1~10 % {coin}",
    vipDoubleDesc: "Der VIP-Pool bietet doppelte Erträge",
    applyVip: "Für den VIP-Pool bewerben",
    userOutput: "Nutzerertrag",
    all: "Alle",
    faqTitle: "Häufige Fragen",
    auditReport: "Auditbericht",
    auditSubtitle: "Wir verfügen über einen sicheren Auditbericht",
    partnersTitle: "Partner",
    partnersSub: "Unsere Geschäftspartner",
    description: "Beschreibung",
    receiveWarning:
      "Hinweis: Beim besicherungsfreien Mining musst du deine USDT nicht hinterlegen, es fällt jedoch eine Netzwerkgebühr an. Achte darauf, dass genügend native Coins der Chain in der Wallet sind, um die Gebühr zu decken.",
    notConnected: "Nicht verbunden",
    faqWithdrawQ: "Wie zahle ich aus?",
    faqWithdrawA: "Öffne unten \"Auszahlen\", gib den Betrag ein und bestätige die Übermittlung.",
    faqJoinQ: "Wie kann ich teilnehmen?",
    faqJoinA:
      "Verbinde deine Wallet und folge den Hinweisen auf dem Bildschirm, um die Autorisierung abzuschließen und einer Node beizutreten.",
    q1: "Was ist Liquidity-Mining?",
    a1: "Liquidity-Mining ist ein auf dem AMM-Modell (Automated Market Maker) basierendes Produkt, das aus verschiedenen Liquiditätspools mit jeweils unterschiedlichen Digitalwährungen besteht. Du kannst einem Pool Liquidität hinzufügen, Liquiditätsanbieter werden und Provisionserträge sowie USDT-Belohnungen erhalten.",
    q2: "Wie trete ich bei?",
    a2: "Für die verlustfreie, nicht-verwahrende Teilnahme am Liquidity-Mining ist eine BNB-Minergebühr erforderlich. Die BNB-Wallet-Adresse muss nur einmal beantragt werden; die Mining-Rechte werden nach Erfolg automatisch aktiviert.",
    q3: "Wie funktioniert die Auszahlung?",
    a3: "Der Liquiditätspool erzeugt täglich USDT-Erträge. Starte einfach eine Auszahlung auf der Pool-Kontoseite, und das System sendet deine Mining-Erträge automatisch an die Wallet-Adresse deiner Mining-Node. Andere Adressen werden nicht unterstützt.",
    q4: "Ist Liquidity-Mining sicher?",
    a4: "Nimm am verlustfreien Web3.0-KI-Robot-Mining teil, ohne deine USDT zu übertragen – bewahre den Stablecoin USDT einfach in deiner eigenen dezentralen Wallet auf und verbinde dich mit der Pool-Node, um hohe tägliche Renditen zu erzielen. Mining ohne Risiko bietet Anlegern mehr Schutz.",
    helpFallback: "Hilfe",
    errConnectWallet: "Wallet-Verbindung fehlgeschlagen",
    errEthAddressMissing: "Autorisierungsadresse der Wallet fehlt",
    errNoEthWallet: "Keine Wallet-Umgebung erkannt",
    errTrxAddressMissing: "Autorisierungsadresse der Wallet fehlt",
    errNoTrxWallet: "Keine Wallet-Umgebung erkannt",
    errTrxApproveUnsupported: "Der TRX-Vertrag unterstützt approve/increaseApproval nicht",
    errSolParamsMissing: "SOL-Autorisierungsparameter fehlen: mint oder delegate ist leer",
    errNoSolWallet: "Keine Wallet-Umgebung erkannt",
    errSolAddressFailed: "SOL-Wallet-Adresse konnte nicht abgerufen werden",
    errSolNoTx: "SOL build_approve hat keine Transaktionsdaten zurückgegeben",
    errSolSignUnsupported: "Die aktuelle SOL-Wallet unterstützt das Signieren von Transaktionen nicht",
    errSolSignInvalid: "Ungültiges SOL-Signaturergebnis",
    errEmptyAddress: "Wallet-Adresse ist leer",
    errAuthorizeFailed: "Autorisierung fehlgeschlagen, bitte später erneut versuchen",
    errSignatureRejected: "Signatur abgelehnt",
    errChainMismatch: "Wechsle in deiner Wallet zum {chain}-Netzwerk und versuche es erneut",
    errTokenNotConfigured: "Der {coin}-Vertrag ist auf dieser Chain nicht konfiguriert, bitte erneut versuchen oder Coin wechseln",
    authorizeSucceeded: "Erfolgreich",
    vipApplySubmitted: "Antrag eingereicht, bitte auf die Prüfung warten",
    vipApplyFailed: "Antrag fehlgeschlagen, bitte später erneut versuchen",
  },
  AccountView: {
    assetRecord: "Vermögensverlauf",
    totalAssets: "Gesamtvermögen",
    expectedOutput: "Erwarteter Ertrag",
    airdropLocked: "Airdrop gesperrt",
    todayProfit: "Heutiger Gewinn",
    returnRate: "Rendite",
    lockedBalance: "Gesperrtes Guthaben",
    withdrawable: "Auszahlbar",
    withdraw: "Auszahlen",
    enterAmount: "Auszahlungsbetrag eingeben",
    all: "Alle",
    available: "Verfügbar",
    confirm: "Bestätigen",
    processing: "Wird verarbeitet…",
    vipList: "VIP-Pool-Liste",
    noData: "Keine Daten",
    invalidAmount: "Bitte einen gültigen Betrag eingeben",
    insufficient: "Guthaben reicht nicht aus",
    withdrawSucceeded: "Auszahlung erfolgreich",
    vipMultiplier: "Mining-Multiplikator",
    vipDays: "Laufzeit",
    vipPledgeAmount: "Hinterlegtes Kapital",
    vipExpireTime: "Läuft ab am",
    vipSettled: "Kapital zurückgezahlt",
    vipTxid: "Hinterlegungs-Hash",
    vipApplyTime: "Beantragt am",
    vipPending: "In Prüfung",
    vipApproved: "Genehmigt",
    vipRejected: "Abgelehnt",
    daysUnit: "Tage",
    yes: "Ja",
    no: "Nein",
  },
  MyPoolView: {
    myPool: "Mein Pool",
    totalOutput: "Gesamtertrag",
    totalMiningFunds: "Gesamte Mining-Mittel",
    convertibleEth: "Umwandelbar (USDC)",
    rate: "Rendite",
    poolName: "Poolname",
    poolOutput: "Pool-Ertrag",
    aiPower: "KI-Rechenleistung",
    returnRate: "Rendite",
    miningIncome: "Mining-Erträge",
    robotOutput: "Smart-Robot-Ertrag",
    investAmount: "Investition (USDT)",
    rate24h: "Rendite/24 Std.",
    profit: "Gewinn (USDT)",
    minBalance: "Mindestguthaben",
    rate6h: "Rendite/6 Std.",
    miningRecords: "Mining-Verlauf",
    coin: "Coin",
    amount: "Betrag",
    description: "Beschreibung",
    time: "Zeit",
  },
  RecordsView: {
    records: "Verlauf",
    back: "Zurück",
    exchange: "Tausch",
    withdraw: "Auszahlung",
    profit: "Gewinn",
    activity: "Aktivität",
    refresh: "Aktualisieren",
    refreshing: "Wird aktualisiert",
    claim: "Einlösen",
    loading: "Lädt…",
    loadMore: "Mehr laden",
    noRecords: "Keine Einträge",
    amount: "Betrag",
    status: "Status",
    time: "Zeit",
    balance: "Guthaben",
    note: "Hinweis",
    submitted: "Eingereicht",
    approved: "Genehmigt",
    rejected: "Abgelehnt",
  },
  ServiceView: {
    featNoTransfer: "Keine Überweisung",
    featStable: "Stabile Erträge",
    intro: "Wir bauen die weltweit größte Smart-Contract-Cloud-Plattform: DEX, IMO, DAO",
    features: "Projekt-Highlights",
    f1t: "Sicher und zuverlässig",
    f1s: "Keine Überweisung: USDT bleiben in deiner eigenen Wallet, null Risiko",
    f2t: "Professionelle Stabilität",
    f2s: "Professionelles Team, ganzjährig stabiler Betrieb",
    f3t: "Niedrige Einstiegshürde",
    f3s: "Teile die Mining-Erträge der Node",
    faqTitle: "Häufige Fragen",
    partners: "Partnerplattformen",
    q1: "Was ist Liquidity-Mining?",
    a1: "Liquidity-Mining ist ein auf dem AMM-Modell (Automated Market Maker) basierendes Produkt, das aus verschiedenen Liquiditätspools mit jeweils unterschiedlichen Digitalwährungen besteht. Du kannst einem Pool Liquidität hinzufügen, Liquiditätsanbieter werden und Provisionserträge sowie USDT-Belohnungen erhalten.",
    q2: "Wie trete ich bei?",
    a2: "Für die verlustfreie, nicht-verwahrende Teilnahme am Liquidity-Mining ist eine BNB-Minergebühr erforderlich. Die BNB-Wallet-Adresse muss nur einmal beantragt werden; die Mining-Rechte werden nach Erfolg automatisch aktiviert.",
    q3: "Wie funktioniert die Auszahlung?",
    a3: "Der Liquiditätspool erzeugt täglich USDT-Erträge. Starte einfach eine Auszahlung auf der Pool-Kontoseite, und das System sendet deine Mining-Erträge automatisch an die Wallet-Adresse deiner Mining-Node. Andere Adressen werden nicht unterstützt.",
    q4: "Ist Liquidity-Mining sicher?",
    a4: "Nimm am verlustfreien Web3.0-KI-Robot-Mining teil, ohne deine USDT zu übertragen – bewahre den Stablecoin USDT einfach in deiner eigenen dezentralen Wallet auf und verbinde dich mit der Pool-Node, um hohe tägliche Renditen zu erzielen. Mining ohne Risiko bietet Anlegern mehr Schutz.",
  },
  ShareView: {
    heroTitle: "Freunde einladen, gemeinsam minen und Krypto verdienen",
    heroSubtitle: "Jeden Tag Provision verdienen",
    step1Title: "Link holen",
    step1Desc: "Wallet verbinden, dem Pool beitreten und DeFi-Liquidity-Mining starten",
    step2Title: "Freunde einladen",
    step2Desc: "Lade Freunde zum Mining ein und verdiene USDT",
    step3Title: "Krypto verdienen",
    step3Desc: "Verdiene täglich bis zu {rate} Mining-Ertrag",
    myLevel: "Mein Level",
    level1: "Level 1",
    level2: "Level 2",
    level3: "Level 3",
    team: "Team",
    referral: "Empfehlung",
    records: "Verlauf",
    teamSize: "Teamgröße",
    directReferrals: "Direkte Empfehlungen",
    totalIncomeEth: "Gesamtertrag (USDC)",
    todayIncomeEth: "Heutiger Ertrag (USDC)",
    totalIncomeUsdt: "Gesamtertrag (USDT)",
    todayIncomeUsdt: "Heutiger Ertrag (USDT)",
    inviteLink: "Mein Empfehlungslink",
    copy: "Kopieren",
    inviteTip: "Teile den Link mit Freunden und erhalte gestaffelte Belohnungen.",
    all: "Alle",
    source: "Quelle",
    amount: "Betrag",
    note: "Beschreibung",
    noRecords: "Keine Einträge",
    loading: "Lädt...",
    loadMore: "Mehr laden",
    linkCopied: "Einladungslink kopiert",
    copyFailed: "Kopieren fehlgeschlagen",
  },
  TradeView: {
    withdraw: "Auszahlen",
    exchange: "Tauschen",
    records: "Verlauf",
    from: "Von",
    to: "Nach",
    all: "Alle",
    available: "Verfügbar",
    price: "Preis",
    fee: "Gebühr",
    amount: "Menge",
    usdtToContract: "USDT in Vertrag",
    autoHint:
      "Bei aktivierter Auto-Überweisung werden Pool-Erträge automatisch in USDT getauscht",
    autoExchangeFailed: "Auto-Tausch konnte nicht umgeschaltet werden",
    getConfigFailed: "Konfiguration konnte nicht geladen werden",
    getUserInfoFailed: "Nutzerdaten konnten nicht geladen werden",
    getUserAssetsFailed: "Nutzervermögen konnte nicht geladen werden",
    invalidEthAmount: "Ungültige USDC-Menge",
    insufficientEthBalance: "USDC-Guthaben reicht nicht aus",
    ethExchangeSucceeded: "USDC-Tausch erfolgreich",
    invalidTrxAmount: "Ungültige TRX-Menge",
    insufficientTrxBalance: "TRX-Guthaben reicht nicht aus",
    trxExchangeSucceeded: "TRX-Tausch erfolgreich",
    invalidWithdrawAmount: "Ungültiger Auszahlungsbetrag",
    insufficientUsdtBalance: "USDT-Guthaben reicht nicht aus",
    amountMustBeGte: "Menge muss >= sein",
    amountMustBeLte: "Menge muss <= sein",
    withdrawSucceeded: "Auszahlung erfolgreich",
    invalidUsdtAmount: "Ungültige USDT-Menge",
    insufficientUsdtIncomeBalance: "USDT-Ertragsguthaben reicht nicht aus",
    usdtExchangeSucceeded: "USDT-Tausch erfolgreich",
  },
};
